import React from "react";
import { PawPrint, Leaf, Sprout, Wifi, ParkingCircle } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import Reveal from "./Reveal";

const ICONS = [PawPrint, Leaf, Sprout, Wifi, ParkingCircle];

export const EngagementBadges = ({ className = "" }) => {
  const { t } = useI18n();
  const items = t("badges.items");
  return (
    <section className={`py-16 lg:py-24 bg-brand-900 text-white ${className}`} data-testid="engagement-badges">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center mb-12">
          <p className="text-brand-200 font-accent text-2xl italic">{t("badges.title")}</p>
        </Reveal>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {items.map((label, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={label} delay={i * 70}>
                <div className="group flex flex-col items-center text-center gap-4 rounded-2xl bg-white/[0.04] border border-white/10 px-4 py-8 h-full transition-colors hover:bg-white/[0.09]" data-testid={`badge-${i}`}>
                  <span className="w-14 h-14 rounded-full bg-white/10 ring-1 ring-white/15 flex items-center justify-center transition-transform group-hover:scale-105">
                    <Icon size={24} strokeWidth={1.6} className="text-brand-200" />
                  </span>
                  <span className="font-body text-sm font-medium text-white/90 leading-snug">{label}</span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EngagementBadges;
